import React, { useState, useEffect, useRef } from 'react';
import RichText from '/react4xp/components/RichText'; 
import { CaretUp, CaretDown } from '../Svg/Others/Icons';
import IconWrapper from '/react4xp/components/Icon';

interface FactBoxProps {
    content: string;
    bgColor: 'insights' | 'news' | 'success-stories';
    articleType: 'news' | 'insights' | 'success-stories';
}

export default function FactBox({ content, bgColor, articleType }: FactBoxProps) {
    const [isOpen, setIsOpen] = useState(false);
    const factBoxContentRef = useRef<HTMLDivElement>(null);

    const handleToggle = () => {
        setIsOpen(prevState => !prevState);
    };

    useEffect(() => {
        const factBoxContent = factBoxContentRef.current;

        if (factBoxContent) {
            factBoxContent.style.setProperty('--fade-color', bgColor);
        }
    }, [bgColor]);

    return (
        <div
            className={`fact-box ${isOpen ? 'fact-box--open' : ''} fact-box--${articleType}`}
        >
            <div className="fact-box__item">
                <div
                    // className="fact-box__content rich-text"
                    className={`fact-box__content${isOpen ? '--open' : ''} rich-text`}
                    aria-hidden={!isOpen}
                    tabIndex={-1}
                    ref={factBoxContentRef}
                >
                    <div className="fact-box__text rich-text">
                        <RichText content={content} />
                    </div>
                </div>
                <button
                    className="fact-box__btn"
                    aria-expanded={isOpen}
                    onClick={handleToggle}
                >
                    {isOpen ? 'See less' : 'See more'}
                    <IconWrapper
                        IconComponent={isOpen ? CaretUp : CaretDown}
                        iconColor="primary"
                        iconSide="right"
                        iconSize="sm"
                    />
                </button>
            </div>
        </div>
    );
}
